<template>
  <div class="aside-menu">
    <div class="notifications-list">
      <transition-group name="notification-list" tag="div">
        <div class="notification" v-for="(item, i) in notifications" :key="item.id + i.toString()">
          <AppNotification :notification="item"
                           :removable="true"
                           pop-up
                           @remove-notification="closePopupNotification"
                           @close-widget="toggleNotificationWidget"
                           @show-event-modal="showEventDetailModal"
          />
        </div>
      </transition-group>
    </div>

    <AppAsideMenuList :notification-widget-active="notificationWidgetActive"
                      :notification-counter="notificationCounter"
                      :dialog-widget-active="dialogWidgetActive"
                      :dialog-counter="dialogCounter"
                      @toggle-notification-widget="toggleNotificationWidget"
                      @toggle-dialog-widget="toggleDialogWidget"
    />

    <transition name="fade">
      <ActivityDetailModal v-if="eventModal.active"
                           :activity="eventModal.activity"
                           @close-modal="closeEventDetailModal"
      />
    </transition>

    <!--скрыт до востребования (компонент должен отображать последние несколько диалогов)-->
    <RecentDialogs v-if="false" @set-active-dialog="setActiveDialog"/>
  </div>
</template>

<script>
import ActivityDetailModal from '@/components/page/modal/ActivityDetailModal'
import RecentDialogs from './RecentDialogs'
import AppNotification from './AppNotification'
import AppAsideMenuList from '@/components/aside/AppAsideMenuList'
export default {
  name: 'AppAside',
  components: { AppAsideMenuList, AppNotification, RecentDialogs, ActivityDetailModal },
  data () {
    return {}
  },
  computed: {
    notifications () {
      return this.$store.getters.getPopupNotifications
    },
    eventModal () {
      return this.$store.getters.getWidgetEventModal
    },
    notificationWidgetActive () {
      return this.$store.getters.getNotificationWidgetActive
    },
    notificationCounter () {
      return this.$store.getters.getNewNotificationCounter
    },
    dialogWidgetActive () {
      return this.$store.getters.getDialogWidgetActive
    },
    dialogCounter () {
      return this.$store.getters.getNewDialogCounter
    },
    currentUser () {
      return this.$store.getters.currentUser
    }
  },
  methods: {
    closePopupNotification (notificationId) {
      this.$store.dispatch('closePopupNotification', notificationId)
    },
    toggleNotificationWidget () {
      this.$store.dispatch('getAppNotifications')
      this.notifications.forEach(item => {
        this.closePopupNotification(item.id)
      })
      this.$store.dispatch('toggleNotificationWidget')
    },
    toggleDialogWidget () {
      this.$store.dispatch('toggleDialogWidget')
    },
    setActiveDialog (dialogId) {
      this.$store.dispatch('setActiveDialog', dialogId)
    },
    showEventDetailModal (item) {
      this.$store.commit('[notification] SHOW_DETAIL_EVENT_MODAL', item)
    },
    closeEventDetailModal () {
      this.$store.commit('[notification] CLOSE_DETAIL_EVENT_MODAL')
    }
  },
  mounted () {
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.aside-menu {
  position: fixed;
  z-index: 99999;
  top: 0;
  right: 0;
  left: auto;
  bottom: 0;
  width: 70px;
  background-color: $color_second-dark;
  color: $font_color_alt;
}

.notifications-list {
  position: absolute;
  top: 10px;
  left: -560px;
  right: auto;
  display: flex;
  flex-flow: column nowrap;
}

.notification {
  margin-bottom: 8px;
  transition: all .5s;
}

.menu-list {
  display: flex;
  flex-direction: column;

  &__item {
    margin-bottom: 3px;
  }

  &__link,
  &__button {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    background: $color_second;
    color: $color-main;
    cursor: pointer;
    user-select: none;

    &__counter {
      position: absolute;
      height: 13px;
      min-width: 13px;
      border-radius: 7px;
      padding: 4px;
      top: auto;
      right: 14px;
      bottom: 12px;
      left: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 9px;
      background: $color_fifth;
      user-select: none;
    }
  }

  &__button {
    z-index: 9999;

    &:before,
    &:after {
      position: absolute;
      content: '';
      display: none;
      left: 0;
      right: auto;
      width: 0;
      height: 0;
    }

    &:before {
      top: 0;
      border-top: 35px solid $color_main;
      border-right: 16px solid transparent;
    }

    &:after {
      bottom: 0;
      border-top: 35px solid $color_main;
      border-right: 16px solid transparent;
      transform: scale(1, -1);
    }
  }
}

.router-link-active {
  background: #F65F59;
  background: $button_color;
}
</style>
